import { TAppState } from '../../types/appState';

export const parentOriginSelector = (state: TAppState) => state.parentOrigin;
